// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"708":"c79be85a","787":"aadb7429","921":"6111f255"}[chunkId] + ".chunk.js";
};